import { css } from 'linaria';
import { KitchenStylesInfoBlock } from './components';

export const KITCHEN_STYLES_PATH = '/proekt-kuhni/na-zakaz/';

export const KITCHEN_STYLES_ELEMENT_BLOCK = 'landingProektKuhniStili';

export const KITCHEN_STYLES_LANDING_NAME = 'kitchen-styles';

export const IMAGE_PER_PAGE = 13;
export const IMAGE_INDENT = 3;

export const DESIGN_PROJECT_BLOCK: KitchenStylesInfoBlock = {
  href: '/zapis-onlayn/?department_no=15&region_id=defaultRegion',
  title: 'Бесплатный дизайн-проект кухни',
  target: '_blank',
  btnText: 'Записаться',
  elementText: 'Бесплатный дизайн-проект кухни',
  className: css`
    && {
      grid-row-start: 6;
      height: 258px;
      color: var(--text-invert);
      background-color: var(--control-primary);

      ::before {
        background-image: url(https://cdn.leroymerlin.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen-styles/signup.png/signup.png);
      }

      h2,
      p {
        color: var(--text-invert);
      }

      p:last-of-type {
        color: var(--text-primary);
        background-color: var(--background-primary);
      }

      &:hover p:last-of-type {
        background-color: rgba(255, 255, 255, 0.92);
      }
    }
  `,
};

export const ONLINE_CALCULATOR_BLOCK: KitchenStylesInfoBlock = {
  href: '/kalkulyator-remonta/raschet-stoimosti-kuhni/',
  title: 'Онлайн-калькулятор кухни',
  target: '_blank',
  btnText: 'Узнать цену',
  text: 'Узнайте примерную стоимость кухни',
  elementText: 'Онлайн-калькулятор кухни',
  className: css`
    && {
      grid-row-start: 6;
      height: 258px;
      background-color: #A0B9B1;

      @media (--to-tablet) {
        grid-row-start: 7;
      }

      ::before {
        background-image: url(https://cdn.leroymerlin.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen-styles/calculator-img.png/calculator-img-01.png);
      }

      p:last-of-type {
        color: var(--text-primary-invert);
      }
    }
  `,
};
